<template>
  <div class="shop-subcategories">
    <Draggable
      handle=".handle"
      :value="value"
      :disabled="isLocked"
      @input="
        $ev => {
          $emit('input', $ev)
          $emit('track', 'SubcategoryReorder')
        }
      "
      class="shop-subcategories__content"
    >
      <Subcategory
        v-for="(subcategory, index) in value"
        :key="'subcategory_' + index"
        :category-index="categoryIndex"
        :index="index"
        :value="subcategory"
        :readonly="isLocked"
        @remove="remove(subcategory)"
      >
        <Items
          v-model="subcategory.items"
          :readonly="isLocked"
          :area="$path('metadata.area', subcategory)"
          :categories="categories"
          :pricing-method="pricingMethod"
          @move="$ev => $emit('move', $ev)"
        />
      </Subcategory>
    </Draggable>
    <Subcategory v-if="!isLocked" @click="add" placeholder />
  </div>
</template>

<script>
import Model from '@/models/Shop/subcategory'
import { mapState } from 'vuex'

import Draggable from 'vuedraggable'
import Subcategory from './Subcategory'
import Items from '../Items'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    categories: Array,
    categoryIndex: Number,
    category: Object,
    pricingMethod: String,
  },
  computed: {
    ...mapState('Shop', ['item']),
    isLocked() {
      if (!this.item.id) return

      let subcategory = this.item.categories[this.categoryIndex]
      if (!subcategory) return
      return ['signed', 'accepted'].includes(subcategory.status)
    },
  },
  methods: {
    add() {
      this.$emit('input', [...this.value, Model()])
      this.$nextTick(() => {
        Array.from(this.$el.querySelectorAll('input.shop-subcategory__label')).pop().focus()
      })
    },
    remove(item) {
      this.$emit(
        'input',
        this.value.filter(v => v !== item),
      )
    },
  },
  components: {
    Subcategory,
    Draggable,
    Items,
  },
}
</script>

<style lang="scss">
.shop-subcategories {
  padding: 2rem;
  border: 1px solid var(--border-color);
  border-top: none;
  background-color: white;

  &__content {
    &:not(:empty) + * {
      margin-top: 3rem;
    }
  }
}
</style>
